export function usePostMessage<T>(windowToPost: Window, domain: string) {
  const _window = windowToPost;
  const _domain = domain;
  const sendMessage = async (data: T) =>
    new Promise(rs => {
      _window.postMessage(JSON.stringify(data), _domain);
      setTimeout(() => rs(true), 50);
    });

  const getAsyncMessage = async (): Promise<any> => {
    let resolve: (v?: any) => void = () => {};

    const receiveMessage = (event: MessageEvent) => {
      if (event.origin !== _domain) return;
      else resolve(event.data);
    };

    const promise = new Promise(r => {
      resolve = (data: T) => {
        window.removeEventListener("message", receiveMessage, false);
        r(data);
      };
    });

    window.addEventListener("message", receiveMessage, false);
    return promise;
  };
  return {
    sendMessage,
    getAsyncMessage,
  };
}
